import { FormControl } from '@@/form-components/FormControl';
import { Switch } from '@@/form-components/SwitchField/Switch';
import { FormSection } from '@@/form-components/FormSection';

import { KubernetesSecurityFormValues } from './types';

interface PodSecurityConstraintsSectionProps {
  formData: KubernetesSecurityFormValues;
  onChange: <K extends keyof KubernetesSecurityFormValues>(
    key: K,
    value: KubernetesSecurityFormValues[K]
  ) => void;
}

export function PodSecurityConstraintsSection({
  formData,
  onChange,
}: PodSecurityConstraintsSectionProps) {
  return (
    <FormSection title="Pod security constraints">
      <FormControl
        inputId="enable-pod-security-constraints"
        label="Enable pod security constraints"
        size="large"
      >
        <Switch
          id="enable-pod-security-constraints"
          data-cy="enable-pod-security-constraints-toggle"
          name="enablePodSecurityConstraints"
          className="space-right"
          checked={formData.enablePodSecurityConstraints || false}
          onChange={(value) => onChange('enablePodSecurityConstraints', value)}
        />
      </FormControl>
    </FormSection>
  );
}
